export default { sha: '5790d873ab357098818724cb0a0eae8e5fd1be9d', buildNumber: 'undefined' }
